import { CarrierFilters } from "./../model/carrier";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { AuthHeaderService } from "../views/authheader.service";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CarrierService {
  carrierurl: string;
  carrierAvailurl:string;
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.carrierurl = environment.carrierurl;
    this.carrierAvailurl = environment.carrierAvailurl;
  }

  SendForm(pageFilters: CarrierFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.carrierurl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getCarrierData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.carrierurl, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCarrierAvailData(st){
    
    let url = this.carrierAvailurl;
    url = url + (st ?`?fromDate=${st}`:'')
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getJobsByCarrierIdId(carrierId: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    const url = `${this.carrierurl}/${carrierId}/jobs`;
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  EditCarrier(obj, id) {
    delete obj["_id"];
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.carrierurl + "/" + id, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  DeleteCarrier(_id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.delete(this.carrierurl + "/" + _id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
